import { mediaQuery, Spacings, Fonts } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';
import BottomSheet from '@comp/BottomSheet/BottomSheet';
import StoreFilter from '@cont/StoreListing/StoreFilter';
import styled from '@emotion/styled';
import { useRef, useState } from 'react';
import Filter from './Filter';
import FilterBottomSheet from './FilterBottomSheet';

const Desktop = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const Mobile = styled.div`
  ${mediaQuery.aboveMobile} {
    display: none;
  }
`;

const LeftWrapper = styled.div`
  width: 224px;
  left: 460px;
`;

const StraightLine = styled.div`
  border: 0.5px solid var(--color-i-divider);
`;

const MobileFilterWrapper = styled.div`
  gap: ${Spacings.SPACING_6};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-left: ${Spacings.SPACING_4B};
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const FilterLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${Spacings.SPACING_8B};
  margin-right: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_6B};
  margin-top: ${Spacings.SPACING_7B};
`;

const ResetButton = styled(AquillaButton)`
  border: 1px solid var(--color-i-divider);
`;

const StyledBottomSheet = styled(BottomSheet)`
  & .MuiDialog-container {
    & .MuiDialog-paperScrollPaper {
      max-height: calc(100vh - 48px) !important;
      min-height: calc(100vh - 230px) !important;
    }
  }
`;

const Filters = ({
  filters,
  onChange,
  onClear,
  onApply,
  filterObj,
  openBottomSheet,
  setOpenBottomSheet,
  resetFilters,
  showResetBtn,
  bottomSheetWrapRef,
  filtersApplied,
  getAllOptionsByFilterName
}) => {
  const [openSelectedFilter, setOpenSelectedFilter] = useState({});

  const mobileFilterRef = useRef(null);

  const handleReset = () => {
    resetFilters(true);
    if (mobileFilterRef.current) {
      mobileFilterRef.current.scrollLeft = 0;
    }
  };

  const handleApply = () => {
    if (mobileFilterRef.current) {
      mobileFilterRef.current.scrollLeft = 0;
    }
    onApply();
  };

  const getSelectionBasedFilterOrder = () => {
    const allFilters = filters.filter((filter) => filter.key !== 'sort_by');
    const sortByFilter = filters.filter((filter) => filter.key === 'sort_by');
    const appliedFilters = allFilters.filter(
      (filter) => filterObj[filter.key].length !== 0
    );

    const nonAppliedFilters = allFilters.filter(
      (filter) => filterObj[filter.key].length === 0
    );
    return Object.keys(sortByFilter).length
      ? [...sortByFilter, ...appliedFilters, ...nonAppliedFilters]
      : [...appliedFilters, ...nonAppliedFilters];
  };

  return (
    <>
      <Desktop>
        <LeftWrapper>
          <FilterLabel>
            <Typography variant="h4">
              {filtersApplied > 0 ? `Filters (${filtersApplied})` : 'Filters'}
            </Typography>
            {showResetBtn && (
              <ResetButton
                label="RESET"
                size="small"
                variant="secondary"
                onClick={resetFilters}
              />
            )}
          </FilterLabel>
          <StraightLine />
          {filters?.map((filter, index) => {
            return (
              <Filter
                key={filter.key}
                filter={filter}
                filterObj={filterObj}
                resetFilters={resetFilters}
                index={index}
                onChange={onChange}
                onClear={onClear}
                getAllOptionsByFilterName={getAllOptionsByFilterName}
              />
            );
          })}
        </LeftWrapper>
      </Desktop>
      <Mobile>
        <MobileFilterWrapper ref={mobileFilterRef}>
          {getSelectionBasedFilterOrder().map((filter) => {
            return (
              <StoreFilter
                key={filter.key}
                setOpenBottomSheet={setOpenBottomSheet}
                filter={filter}
                selected={filterObj[filter.key]}
                onSelection={setOpenSelectedFilter}
              />
            );
          })}
        </MobileFilterWrapper>
        {openBottomSheet && (
          <StyledBottomSheet open contentContainerStyle="padding: 0px">
            <FilterBottomSheet
              bottomSheetWrapRef={bottomSheetWrapRef}
              openSelectedFilter={openSelectedFilter}
              filters={filters}
              filterObj={filterObj}
              onChange={onChange}
              resetFilters={handleReset}
              onClear={onClear}
              onApply={handleApply}
              getAllOptionsByFilterName={getAllOptionsByFilterName}
            />
          </StyledBottomSheet>
        )}
      </Mobile>
    </>
  );
};

export default Filters;
